export const sepaList = [
  'AT',
  'BE',
  'BG',
  'CH',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'LI',
  'LT',
  'LU',
  'LV',
  'MC',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
  'SM',
];

export const sepaCheck = (iban) => {
  if (typeof iban !== 'string') return false;

  const ibanCountryCode = iban?.trim()?.slice(0, 2) || '';

  if (sepaList.includes(ibanCountryCode?.toUpperCase())) {
    return true;
  }

  return false;
};

export const isSameIBAN = (firstIBAN, secondIBAN) => {
  const sanitizedFirstIBAN = firstIBAN ? firstIBAN.replace(/[\s]/g, '') : '';
  const sanitizedSecondIBAN = secondIBAN ? secondIBAN.replace(/[\s]/g, '') : '';

  return sanitizedFirstIBAN && sanitizedSecondIBAN && sanitizedFirstIBAN === sanitizedSecondIBAN;
};

export const maskIBAN = (iban = '') => {
  const sanitizedIban = iban ? iban.replace(/[\s]/g, '') : '';

  return sanitizedIban.length >= 4
    ? `
    ${sanitizedIban.substring(0, 4)}
    ${Array.from({ length: 16 }).join('*')}
    ${sanitizedIban.substring(sanitizedIban.length - 4)}
    `
    : '';
};
